export default __webpack_public_path__ + "static/media/indentified_visitor.03af49cd.png";